<template lang="html">
  <div>
    <v-layout :wrap="$vuetify.breakpoint.xsOnly">
      <v-flex
        xs12
        sm6
      >
        <v-layout wrap>
          <!-- <v-flex xs12 class="headline ">
              {{formattedMoneyValue(price)}}
            </v-flex> -->
          <v-flex mb-4>
            <template v-for="(item, i) in items">
              <v-layout
                :key="i"
                py-2
                align-center
              >
                <v-flex>
                  {{ item.text }}
                </v-flex>
                <v-flex shrink>
                  {{ item.price }}
                </v-flex>
              </v-layout>
              <!-- <v-divider :key="`divider_${i}`" /> -->
            </template>
            <v-divider />
            <v-layout
              py-2
              align-center
            >
              <v-flex class="font-weight-bold">
                TOTAL (incl GST)
              </v-flex>
              <v-flex
                shrink
                class="font-weight-bold headline"
              >
                {{ formattedMoneyValue(price) }}
              </v-flex>
            </v-layout>
            <v-divider />
          </v-flex>

          <v-flex
            pa-0
            xs12
          >
            <slot />
          </v-flex>
        </v-layout>
      </v-flex>

      <v-divider
        v-if="$vuetify.breakpoint.smAndUp"
        vertical
        class="mx-3"
      />

      <v-flex
        xs12
        sm6
      >
        <v-form
          ref="form"
          v-model="clientValid"
        >
          <v-layout wrap>
            <v-flex
              xs6
              py-0
            >
              <SiInputText
                v-model="client.firstName"
                filled
                label="First name"
                required
                :rules="[_ruleRequired('First name is required')]"
              />
            </v-flex>
            <v-flex
              xs6
              py-0
            >
              <SiInputText
                v-model="client.lastName"
                filled
                label="Last name"
                required
                :rules="[_ruleRequired('Last name is required')]"
              />
            </v-flex>
            <v-flex
              xs12
              py-0
            >
              <SiInputText
                v-model="client.email"
                label="Email"
                required
                filled
                :color="govEmailWarning ? 'warning': ''"
                :messages="govEmailWarning"
                :rules="[_ruleRequired('A valid email is required'), _ruleEmail()]"
              />
            </v-flex>
            <v-flex
              v-if="phone"
              xs12
              py-0
            >
              <SiInputText
                v-model="client.phone"
                filled
                label="Phone number"
                required
                :rules="[_ruleRequired('Phone number is required in case we need to contact you about your calculation')]"
              />
            </v-flex>
            <v-flex
              v-if="allowClientReference"
              xs12
              py-0
            >
              <SiInputText
                v-model="client.reference"
                filled
                label="Your reference"
              />
            </v-flex>
            <v-flex
              v-if="!hideClientType"
              xs12
              py-0
            >
              <SiInputSelect
                v-model="client.type"
                filled
                label="Who are you completing this calculation for?"
                :items="[{text: 'For myself (personal)', value: 'personal'},{text: 'For my client (agent)', value: 'agent'}]"
                required
                :rules="[_ruleRequired('You must nominate who you are completing this calculation for')]"
              />
            </v-flex>
          </v-layout>
        </v-form>
        <v-layout wrap>
          <v-flex
            v-if="hasPrice"
            xs12
            py-0
          >
            <v-alert
              v-if="!!stripeError"
              type="error"
              v-html="stripeError"
            />
            <v-input
              class="v-input v-text-field v-text-field--filled v-text-field--enclosed theme--light stripe"
              :class="{'v-input--is-focused primary--text': cardFocused}"
              :messages="stripeMessages"
              :error="(stripeMessages || []).length > 0"
            >
              <div
                id="card-element"
                class="flex"
                style="padding:18px 0 0 0"
              >
                <!-- A Stripe Element will be inserted here. -->
              </div>
            </v-input>
          </v-flex>
          <v-flex xs12>
            <v-btn
              large
              block
              color="primary"
              :loading="processing || loading"
              :disabled="processing || loading || disabled"
              class="mx-0"
              @click="() => checkout('stripe')"
            >
              {{ buttonText }}
            </v-btn>
          </v-flex>
          <v-flex
            v-if="hasPrice"
            xs12
          >
            <v-layout
              justify-center
              ma-0
            >
              <v-flex
                shrink
                text-right
                style="width:120px"
              >
                <v-img
                  :src="require('@/assets/powered_by_stripe.png')"
                  contain
                  width="120"
                />
              </v-flex>
            </v-layout>
          </v-flex>

          <v-expand-transition>
            <v-flex
              v-if="allowInvoicing && invoicingEnabled && hasPrice"
              xs12
            >
              <v-layout
                align-center
                ma-0
              >
                <v-divider />
                <v-flex
                  shrink
                  text-center
                  class="grey--text"
                >
                  OR
                </v-flex>
                <v-divider />
              </v-layout>
              <v-alert
                v-if="!!invoiceError"
                type="error"
                v-html="invoiceError"
              />
              <v-btn
                large
                block
                color="primary"
                :loading="processing || loading"
                :disabled="processing || loading || disabled"
                class="mx-0"
                @click="() => checkout('invoice')"
              >
                Invoice Me
              </v-btn>
            </v-flex>
          </v-expand-transition>
        </v-layout>
      </v-flex>
      
      <v-overlay v-if="processing">
        <v-flex
          pa-0
          shrink
        >
          <v-layout
            ma-0
            align-center
            justify-center
            class="headline white--text"
          >
            <v-icon
              left
              color="white"
            >
              lock
            </v-icon> {{ processingText }}
          </v-layout>
          <v-progress-linear
            :indeterminate="true"
            color="teal accent-2"
            height="2"
          />
        </v-flex>
      </v-overlay>
    </v-layout>
    <v-flex
      xs12
      px-0
      mt-4
    >
      <v-alert
        v-if="allowInvoicing"
        type="info"
        icon="email"
        class="ma-0"
        outlined
      >
        <div class="font-weight-bold">
          Invoicing
        </div>
        If you are a profesional services firm and unable to pay using a credit card, 
        we offer invoicing to approved clients.
        <br>Contact us on 
        <a
          href="tel:1300362400"
          style="color: inherit"
        >1300 362 400</a> or via our 
        <router-link
          to="/contact"
          style="color: inherit"
        >
          contact page
        </router-link>.
      </v-alert>
      <v-alert
        v-else
        type="info"
        icon="email"
        class="ma-0"
        outlined
      >
        We require your email to send permanent links to calculations, communicate with you for services we are providing, and compliant record keeping. 
        <br> You will <strong>NOT</strong> be subscribed to newsletters, receive promotional material, or be contacted without due reason.
        <br>See our <a
          href="https://superinfo.com.au/privacy"
          style="color: inherit"
        >privacy policy</a> for more information.
      </v-alert>
    </v-flex>
  </div>
</template>

<script>
import axios from "axios";
import uniqid from "uniqid";
import { mapGetters } from "vuex";
import { forEach } from "lodash";
import helpers from "@/mixins/helpers";
import { rtdb } from "@/plugins/firebase";
import validation from "@/mixins/validations";
import clientPath from "@/plugins/client-path";

export default {
  mixins: [helpers, validation],
  props: {
    skus: {
      type: Array,
      default: () => []
    },
    clientDetails: {
      type: Object,
      default: () => ({})
    },
    transactionId: {
      type: String,
      required: true,
    },
    registerPaths: {
      type: Array,
      required: true,
    },
    registerPathsDb: {
      type: Array,
      required: true,
    },
    chargeDescription: {
      type: String,
      default: "",
    },
    checkoutId: {
      type: String,
      default: ''
    },
    disabled: Boolean,
    phone: Boolean,
    metadata: {
      type: Object,
      default: () => ({})
    },
    allowInvoicing: Boolean,
    loading: Boolean,
    hideClientType: Boolean,
    defaultButtonText: {
      type: String, 
      default: 'Retrieve'
    },
    allowClientReference: Boolean
  },
  data() {
    return {
      lazySkus: [],
      client: {},
      clientValid: false,
      calculationProgress: 0,
      stripeServerAttempt: 0,
      cardFocused: "",
      card: "",
      processing: false,
      processingText: "Processing Payment...",
      stripe: null,
      stripeMessages: [],
      stripeError: "",
      invoiceError: "",
      stripeValid: false,
      start: null,
      invoicingEnabled: false,
      checkEmailTimeout: null,
      checkEmailId: null,
    };
  },
  computed: {
    ...mapGetters(["_products"]),
    items() {
      let items = [];
      forEach(this.lazySkus, (sku) => {
        if (typeof sku === "string") {
          let product = this._products[sku] || {};
          items.push({
            text: product.receiptText,
            price: this.formattedMoneyValue(product.price),
          });
        }
      });
      return items;
    },
    googleItems() {
      return this.lazySkus
        .filter((sku) => typeof sku === "string")
        .map((sku, i) => {
          let p = this._products[sku] || {};
          return {
            id: sku,
            name: p.receiptText,
            list_name: "Super Info",
            brand: "Super Info",
            category: sku.split("_")[0],
            variant: sku.split("_")[1] || "",
            list_position: i,
            quantity: 1,
            price: Number(p.price) / 100,
          };
          // items.push({ text: product.receiptText, price: this.formattedMoneyValue(product.price) })
        });
    },
    googlePurchase() {
      return {
        transaction_id: this.transactionId,
        affiliation: "Super Info Online",
        value: this.price / 100,
        currency: "AUD",
        tax: this.price / 100 / 11,
        shipping: 0,
        items: this.googleItems,
      };
    },
    price() {
      let price = 0;
      forEach(this.lazySkus, (sku) => {
        if (typeof sku === "string")
          price += (this._products[sku] || {}).price || 0;
      });
      return price;
    },
    hasPrice() {
      return this.price > 0;
    },
    buttonText() {
      return this.hasPrice
        ? `Purchase ${this.formattedMoneyValue(this.price)}`
        : this.defaultButtonText;
    },
    checkEmailUrl() {
      return `${process.env.VUE_APP_API_URL}/invoices/enabled-for`;
    },
    requestMetadata() {
      let { email, firstName, lastName } = this.client;
      let name = `${firstName} ${lastName}`;
      let metadata = this.metadata || {};

      return { email, name, ...metadata };
    },
    govEmailWarning () {
      const warnList = [
        '@defence.gov'
      ]
      return this.client.email 
        ? warnList.some(x => this.client.email.includes(x)) 
          ? "Some government agencies may restrict our emails, please consider using a personal email address."
          : undefined
        : undefined
      
    }
  },
  watch: {
    hasPrice() {
      requestAnimationFrame(() => {
        this.initStripe();
      });
    },
    skus: {
      handler(v) {
        this.lazySkus = v;
      },
      immediate: true,
    },
    clientDetails: {
      handler(v) {
        if (v && typeof v === "object") this.client = v;
      },
      immediate: true,
    },
    async "client.email"(email) {
      this.invoicingEnabled = false;
      if (this.checkEmailTimeout) clearTimeout(this.checkEmailTimeout);
      if (!email) return null;

      this.checkEmailTimeout = setTimeout(async () => {
        let reqId = uniqid();

        this.checkEmailId = reqId;

        let { data: result } = await axios.post(this.checkEmailUrl, {
          reqId,
          email,
        });
        let enabled = (result.reqId = this.checkEmailId && result.enabled);
        this.invoicingEnabled = enabled;
        if (enabled)
          setTimeout(() => {
            this.$vuetify.goTo(document.body.scrollHeight, { duration: 200 });
          }, 300);
      }, 500);
    },
  },
  beforeDestroy() {
    if (this.card) this.card.destroy();
  },
  mounted() {
    this.$loadScript("https://js.stripe.com/v3/").then(() => {
      this.stripe = Stripe(process.env.VUE_APP_STRIPE_KEY); // eslint-disable-line no-undef
      this.initStripe();
    });
    axios.post(this.checkEmailUrl, { email: "", reqId: uniqid() }); // fires up the api to reduce response time
  },
  methods: {
    initStripe() {
      if (!this.hasPrice) {
        if (this.card) this.card.destroy();
        this.card = null;
        return;
      }

      if (this.card) return;

      this.card = this.stripe
        .elements()
        .create("card", { style: { base: { fontSize: "16px" } } });
      this.card.mount("#card-element");

      this.card.addEventListener("change", (event) => {
        this.stripeValid = event.complete;
        if (event.error) {
          this.stripeMessages = [event.error.message];
        } else {
          this.stripeMessages = [];
        }
      });

      this.card.addEventListener("focus", () => {
        this.cardFocused = true;
      });
      this.card.addEventListener("blur", () => {
        this.cardFocused = false;
      });
    },
    formattedMoneyValue(price) {
      if (price > 0) {
        return this._$(price);
      } else {
        return "FREE";
      }
    },
    checkout(method) {
      const invoice = method === "invoice" && this.allowInvoicing;
      const formValid = () => {
        return this.hasPrice && !invoice
          ? this.stripeValid && this.clientValid
          : this.clientValid;
      };

      if (!formValid()) {
        this.$refs.form.validate();
        if (
          this.hasPrice &&
          !invoice &&
          !this.stripeValid &&
          (this.stripeMessages || []).length === 0
        )
          this.stripeMessages.push("Credit card information is incomplete");
        return;
      }

      clientPath.identify(
        this.client.email,
        `${this.client.firstName} ${this.client.lastName}`
      );
      clientPath.tag(this.client.type);

      if (invoice) {
        this.raiseInvoice();
      } else if (this.hasPrice) {
        this.raisePayment();
      } else {
        // this.$emit('finalised', this.client)
        this.finalizePayment();
      }
    },
    async raiseInvoice() {
      const invoicePath = `invoicing/invoices/${this.transactionId}`

      this.processingText = 'Generating Invoice'
      this.processing = true;

      let request = {
        transactionId: this.transactionId,
        client: this.client,
        timestamp: new Date().toISOString(),
        skus: this.lazySkus,
        registerPaths: this.registerPaths,
        registerPathsDb: this.registerPathsDb,
        description: this.chargeDescription,
        metadata: this.requestMetadata,
        ...(this.checkoutId ? { checkoutId: this.checkoutId} : {}),
      };

      await rtdb
        .ref(`${invoicePath}/request`)
        .set(request)

      const dbRef = rtdb.ref(`${invoicePath}/outcome`);


      dbRef.on("value", (s) => {
        const outcome = s.val();
        if (outcome) {
          dbRef.off();
          switch (outcome.type) {
            case "success":
              this.finalizePayment();
              this.processingText = "Invoice Sent";
              break;
            case "error":
              this.$emit("error");
              this.invoiceError = `Error creating invoice. Please contact us for support`;
              this.processing = false;
              break;
            default:
              this.$emit("error");
              this.invoiceError = `Error creating invoice. Please contact us for support`;
              this.processing = false;
          }
        }
      });
    },
    raisePayment() {
      this.start = Number(new Date());
      this.processing = true;
      this.processingText = "Processing Payment";
      this.stripeError = null;
      // HERE
      this.stripe.createToken(this.card).then((result) => {
        if (result.error) {
          this.processing = false;
          this.stripeMessages = [result.error.message];
        } else {
          this.stripeMessages = [];

          var paymentRequest = {
            token: result.token,
            transactionId: this.transactionId,
            client: this.client,
            timestamp: new Date().toISOString(),
            skus: this.lazySkus,
            registerPaths: this.registerPaths,
            registerPathsDb: this.registerPathsDb,
            description: this.chargeDescription,
            metadata: this.requestMetadata,
            ...(this.checkoutId ? { checkoutId: this.checkoutId} : {}),
          };

          this.processPayment(this._removeUndefined(paymentRequest));
        }
      });
    },
    processPayment(paymentRequest) {
      let transactionId =
        this.stripeServerAttempt === 0
          ? this.transactionId
          : `${this.transactionId}_reattempt_${this.stripeServerAttempt}`;
      this.stripeServerAttempt++;

      rtdb.ref(`stripe/charges/${transactionId}/request`).set(paymentRequest);

      const dbRef = rtdb.ref(`stripe/charges/${transactionId}/outcome`);

      dbRef.on("value", (s) => {
        var outcome = s.val();
        if (outcome) {
          dbRef.off();
          switch (outcome.type) {
            case "authorized":
              this.finalizePayment();
              this.processingText = "Complete";
              break;
            case "issuer_declined":
              this.$emit("error");
              this.stripeError = `${outcome.seller_message}<br><br>Please contact your card issuer to discuss.`;
              this.processing = false;
              break;
            case "blocked":
              this.$emit("error");
              this.stripeError = `${outcome.seller_message}<br><br>If you feel your payment should not have been blocked please contact us to discuss.`;
              this.processing = false;
              break;
            case "card_declined":
              this.$emit("error");
              this.stripeError = outcome.seller_message;
              this.processing = false;
              break;
            default:
              this.$emit("error");
              this.stripeError = `${outcome.seller_message}<br><br>If you feel your payment should not have been blocked please contact us to discuss.`;
              this.processing = false;
          }
        }
      });
    },
    finalizePayment() {
      if (process.env.NODE_ENV === "production") {
        try {
          // eslint-disable-next-line no-undef
          gtag("event", "purchase", this.googlePurchase);
        } catch (error) {
          console.error(error);
        }
      }
      this.$emit("finalised", this.client);
    },
  },
};
</script>

<style lang="css" scoped>
.loader-holder {
  position: absolute;
  height: 88px;
  width: 88px;
}
.loader-wrap {
  position: relative;
  height: 88px;
  width: 88px;
  margin: 0 auto;
}
</style>
